var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 18.487C16.54 18.487 17.0669 18.3271 17.515 18.0277C17.9632 17.7282 18.3124 17.3026 18.5187 16.8046C18.7249 16.3066 18.7788 15.7586 18.6736 15.23C18.5683 14.7014 18.3087 14.2158 17.9275 13.8348C17.5463 13.4537 17.0607 13.1943 16.532 13.0892C16.0033 12.9842 15.4554 13.0383 14.9575 13.2447C14.4596 13.4511 14.0341 13.8005 13.7348 14.2488C13.4355 14.697 13.2758 15.224 13.276 15.763C13.2763 16.4855 13.5635 17.1784 14.0745 17.6892C14.5855 18.2 15.2785 18.487 16.001 18.487Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.379 26V25.766V25.752C11.379 24.5039 11.8748 23.3069 12.7574 22.4244C13.6399 21.5418 14.8369 21.046 16.085 21.046C17.3331 21.046 18.5301 21.5418 19.4127 22.4244C20.2952 23.3069 20.791 24.5039 20.791 25.752V25.805V25.999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.515 19.261C22.1228 18.2742 22.4548 17.1423 22.4763 15.9836C22.4977 14.8248 22.2079 13.6815 21.637 12.6728C21.0662 11.6642 20.2352 10.8272 19.2306 10.2491C18.2261 9.67095 17.0849 9.37292 15.926 9.38604C14.7671 9.39916 13.633 9.72295 12.6418 10.3237C11.6506 10.9244 10.8388 11.78 10.2909 12.8013C9.74302 13.8226 9.47916 14.9722 9.52685 16.1302C9.57454 17.2882 9.93202 18.4122 10.562 19.385",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.827 21.5C24.8996 20.0466 25.5462 18.3232 25.6945 16.523C25.8429 14.7227 25.487 12.9168 24.6667 11.3074C23.8465 9.69805 22.5943 8.34887 21.0505 7.41104C19.5067 6.47321 17.7323 5.98379 15.926 5.9976C14.1197 6.01141 12.353 6.52791 10.8237 7.48923C9.29443 8.45056 8.06304 9.81873 7.26751 11.4404C6.47199 13.0622 6.14375 14.8734 6.31957 16.6711C6.49539 18.4689 7.16834 20.1822 8.263 21.619",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.f981dc94cd02479e1ec54770ff991e53.svg";
export { ForwardRef as ReactComponent };